import React from 'react';
import WordMatchGameV2 from './games/WordMatchGameV2';

function Games() {
  return (
    <div style={{ padding: 20 }}>
      <h2>Arabic Learning Games 🎮</h2>
      <WordMatchGameV2 />
    </div>
  );
}

export default Games;
